import PropTypes from 'prop-types';
import { useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';

// Modal
const Modal = (props) => {
  const addedClassToBody = useRef();

  useEffect(() => {
    addedClassToBody.current = !document.body.classList.contains('modal-open');
    if (addedClassToBody.current) {
      document.body.classList.add('modal-open');
    }
    return () => {
      if (addedClassToBody.current) {
        document.body.classList.remove('modal-open');
      }
      document.body.removeChild(props.root);
    };
  }, []);

  return (
    <div className="react-modal-dialog">
      <div
        className={`lp-react-modal react-modal modal-content ${
          props.onlySpinner ? 'spinner-only' : ''
        } ${props.className}`}
      >
        {props.onlySpinner ? (
          <div className="spin-wrapper text-center text-muted">
            <i className="fa-solid fa-arrows-rotate fa-spin fa-4x"></i>
          </div>
        ) : (
          props.children
        )}
      </div>
    </div>
  );
};

Modal.propTypes = {
  onlySpinner: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.any,
  root: PropTypes.object
};

Modal.defaultProps = {
  onlySpinner: false,
  className: ''
};

// Header
const Header = (props) => {
  return (
    <div className="modal-header">
      {props.withXIcon && (
        <button className="close" onClick={props.onClose}>
          <span>&times;</span>
          <span className="sr-only">Close</span>
        </button>
      )}
      {props.children}
    </div>
  );
};

Header.propTypes = {
  children: PropTypes.any,
  withXIcon: PropTypes.bool,
  onClose: PropTypes.func
};

Header.defaultProps = {
  withXIcon: true
};

// Body
const Body = (props) => {
  return <div className={`modal-body ${props.className}`}>{props.children}</div>;
};

Body.propTypes = {
  children: PropTypes.any,
  className: PropTypes.string
};

// Footer
const Footer = (props) => {
  return <div className="modal-footer">{props.children}</div>;
};

Footer.propTypes = {
  children: PropTypes.any
};

// Portal
function Portal(props) {
  let rootEl = document.getElementById(props.id);
  if (!rootEl) {
    rootEl = document.createElement('div');
    rootEl.id = props.id;
    rootEl.classList.add('react-modal-overlay');
    if (props.parentClassName) {
      rootEl.classList.add(props.parentClassName);
    }
    document.body.appendChild(rootEl);
  }

  return ReactDOM.createPortal(<Modal {...props} root={rootEl} />, rootEl);
}

Portal.propTypes = {
  id: PropTypes.string,
  parentClassName: PropTypes.string
};

const BasicModal = {
  Container: Portal,
  Header,
  Body,
  Footer
};

export default BasicModal;
